import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { optimizeImageUrlFillSquare } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
var SQUARE_DIMENSION = 32;
export var Pill = function(param) {
    var pill = param.pill, className = param.className;
    var pillContent = pill.pillContent, _pill_linkTo = pill.linkTo, linkTo = _pill_linkTo === void 0 ? "" : _pill_linkTo, onClick = pill.onClick, pillIcon = pill.pillIcon, pillImage = pill.pillImage;
    var isSSR = useIsSSR();
    var imageUrl = pillImage ? optimizeImageUrlFillSquare(pillImage, isSSR, SQUARE_DIMENSION, {
        ignoreResizeTag: true
    }) : undefined;
    if (!pillContent) {
        return null;
    }
    if (imageUrl) {
        return /*#__PURE__*/ _jsx(PillWithImage, {
            pill: pill,
            imageUrl: imageUrl
        });
    }
    return /*#__PURE__*/ _jsxs(PillWrapper, {
        to: linkTo,
        onClick: onClick,
        className: className,
        children: [
            pillIcon ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    pillIcon,
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(PillContent, {
                children: pillContent
            })
        ]
    });
};
var PillWithImage = function(param) {
    var pill = param.pill, imageUrl = param.imageUrl;
    var pillContent = pill.pillContent, _pill_linkTo = pill.linkTo, linkTo = _pill_linkTo === void 0 ? "" : _pill_linkTo, onClick = pill.onClick;
    return /*#__PURE__*/ _jsxs(PillWithImageWrapper, {
        to: linkTo,
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: imageUrl,
                alt: pillContent
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(PillContent, {
                children: pillContent
            })
        ]
    });
};
var PillWrapper = styled(Link).withConfig({
    componentId: "sc-e4ab0621-0"
})([
    "",
    " display:flex;flex:0 0 auto;align-items:center;justify-content:center;height:",
    ";border-radius:",
    ";cursor:pointer;border:1px solid ",
    ";padding:",
    ";",
    "{&:hover{border-color:",
    ";}&:focus-visible{outline:2px solid -webkit-focus-ring-color;outline-offset:-2px;}}"
], TypographyStyles({}), getSpacing("5x"), getSpacing("5x"), Core.border.muted, getSpacing(10, "2x"), responsiveMediaQueries.canHover, Core.border.default);
var PillWithImageWrapper = styled(PillWrapper).withConfig({
    componentId: "sc-e4ab0621-1"
})([
    "padding-left:4px;border-radius:50px;background-color:",
    ";border:1px solid ",
    ";img{display:block;border-radius:50%;width:",
    "px;height:",
    "px;}",
    "{&:hover{border-color:",
    ";}&:focus-visible{outline:2px solid -webkit-focus-ring-color;outline-offset:-2px;}}"
], Core.surface.inverse, Core.border.muted, SQUARE_DIMENSION, SQUARE_DIMENSION, responsiveMediaQueries.canHover, Core.border.default);
var PillContent = styled.span.withConfig({
    componentId: "sc-e4ab0621-2"
})([
    "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;"
]);
